export const TABLES = {
  BUSINESS: 'businesses',
  COUNTRY: 'countries',
  CITY: 'cities',
  LISTING_POLICY: 'listing_policies',
  PRICING_POLICY: 'pricing_policies',
  SERVICE_LOCATION: 'service_locations',
  SHIPPING_POLICY: 'shipping_policies',
  REVIEW: 'reviews',
  BUSINESS_VISIT: 'business_visits',
  CONTACT_LEAD: 'contact_leads',
  PROFILE: 'profiles',
} as const;
